/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import * as appStrings from '@touchplan/strings';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { MaterialModule } from 'src/app/common/material/material-module';
import { PresentationModule } from 'src/app/common/presentation-components/presentation.module';
import { ImportTicketsStateService } from 'src/app/modules/import-tickets/services/import-tickets-state.service';

@Component({
	selector: 'import-tickets-insertion-point-step',
	standalone: true,
	templateUrl: './import-tickets-insertion-point-step.component.html',
	styleUrls: ['./import-tickets-insertion-point-step.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, MaterialModule, PresentationModule, MatDialogModule],
})
export class ImportTicketsInsertionPointStepComponent {
	private importTicketsState = inject(ImportTicketsStateService);
	public appStrings = appStrings;

	public onBack(): void {
		this.importTicketsState.previousStep();
	}

	public onNext(): void {
		this.importTicketsState.nextStep({});
	}

	constructor() {}
}
